module.exports = __webpack_public_path__ + "img/GU.817ccb63.svg";